import { CompanyAPI } from '@api';

const extratoCarteira = (days) => CompanyAPI.extratoCarteira({ days })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { extratoCarteira };
